import { getLaborByJobNumber, createJobLabor, deleteJobLabor, updateJobLabor, resetJobLabor} from "@/services/jobLabor.svc" 
 
 const defaultState = () => ({
  labor: [],
  headers: [
    {
      text: 'Employee',
      value: 'EmployeeName',
      sortable: true,
    },
    {
      text: 'Process Desc',
      value: 'ProcessDesc',
      sortable: false,
    },
    {
      text: 'General Labor',
      value: 'GeneralLabor',
      cellClass: 'general-labor',
      sortable: false,
    },
    {
      text: 'Manual Machine',
      value: 'ManualMachine',
      cellClass: 'manual-machine-bg',
      sortable: false,
    },
    {
      text: 'CNC Lathe',
      value: 'CncLathe',
      sortable: false,
    },
    {
      text: 'CNC Mill',
      value: 'CncMill',
      sortable: false,
    },
    {
      text: 'Engineering',
      value: 'Engineering',
      sortable: false,
    },
    {
      text: 'Shop',
      value: 'Shop',
      sortable: false,
    },
    {
      text: 'Welding',
      value: 'Welding',
      sortable: false,
    },    
    {
      text: 'Act Labor',
      value: 'ActLabor',
      sortable: false,
    },
    {
      text: 'Work Date',
      value: 'DateAdded',
      sortable: true
    },
    {
      text: 'Comments',
      value: 'Comments',
      sortable: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false
    }
  ],
  adminHeaders: [
    {
      text: 'Employee',
      value: 'EmployeeName',
      sortable: true,
    },
    {
      text: 'Process Desc',
      value: 'ProcessDesc',
      sortable: false,
    },
    {
      text: 'General Labor',
      value: 'GeneralLabor',
      sortable: false,
    },
    {
      text: 'Manual Machine',
      value: 'ManualMachine',
      sortable: false,
    },
    {
      text: 'CNC Lathe',
      value: 'CncLathe',
      sortable: false,
    },
    {
      text: 'CNC Mill',
      value: 'CncMill',
      sortable: false,
    },
    {
      text: 'Engineering',
      value: 'Engineering',
      sortable: false,
    },
    {
      text: 'Shop',
      value: 'Shop',
      sortable: false,
    },
    {
      text: 'Welding',
      value: 'Welding',
      sortable: false,
    },    
    {
      text: 'Est Labor',
      value: 'EstLabor',
      sortable: false,
    },
    {
      text: 'Est OT',
      value: 'EstOt',
      sortable: false,
    },
    {
      text: 'Act Labor',
      value: 'ActLabor',
      sortable: false,
    },
    {
      text: 'Act OT',
      value: 'ActOt',
      sortable: false,
    },
    {
      text: 'Comments',
      value: 'Comments',
      sortable: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false
    }
  ]
 })
 
 export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async setLaborByJobNumber({ commit }, { jobNumber, showAll = false }) {
      const labor = jobNumber.length > 0 ? await getLaborByJobNumber(jobNumber, showAll) : []
      commit('SET_LABOR', labor)
    },

    resetLabor({ commit }) {
      commit('SET_LABOR', [])
    },

    async createJobLaborAction({ dispatch }, payload) {
      dispatch('masterboard/incrementLaborByJobNumber', payload.JobNumber, { root: true })
      return await createJobLabor(payload)
    },

    async updateJobLaborAction(_, payload) {
      await updateJobLabor(payload)
    },

    async deleteJobLaborAction({ dispatch }, payload) {
      dispatch('masterboard/decrementLaborByJobNumber', payload.JobNumber, { root: true })
      await deleteJobLabor(payload)
    },

    async resetJobLaborAction({ dispatch }, payload) {
      dispatch('masterboard/incrementLaborByJobNumber', payload.JobNumber, { root: true })
      await resetJobLabor(payload)
    }    
  },

  getters: {
    labor: (state) => state.labor,
    headers: (state) => state.headers,
    adminHeaders: (state) => state.adminHeaders,
    estLaborCost: (state) => state.labor.reduce((sum, item) => sum + parseFloat(item.EstCost), 0),
    actLaborCost: (state) => state.labor.reduce((sum, item) => sum + parseFloat(item.ActCost), 0),
    grandTotalHours: (state) => state.labor.reduce((sum, item) => sum + parseFloat(item.ActLabor), 0)
  },

  mutations: {
    SET_LABOR(state, payload) {
      state.labor = payload
    }
  }
 }